import type { OccurrenceAttachmentWithUrl } from "./occurrenceAttachments";

export const RELEASE_OCCURRENCE_TYPES = [
  { value: "no_access_to_the_site", label: "Sem Acesso ao Local" },
  {
    value: "individual_did_not_leave_the_cage",
    label: "Indivíduo Não Saiu da Gaiola",
  },
];
export const RELEASE_OCCURRENCE_TYPES_VALUES = RELEASE_OCCURRENCE_TYPES.map(
  (option) => option.value,
);
export type ReleaseOccurrenceType =
  (typeof RELEASE_OCCURRENCE_TYPES)[number]["value"];

export interface Occurrence {
  createdAt?: string;
  locationLatitude?: number;
  locationLongitude?: number;
  observations?: string;
  updatedAt?: string;
  type?: string;
  otherType?: string;
  attachments?: OccurrenceAttachmentWithUrl[];
}
